function o(t) {
  var _t$shadowRoot;
  if (!t) return null;
  var e = ["a[href]", "area[href]", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", '[tabindex]:not([tabindex="-1"])'];
  return ((_t$shadowRoot = t.shadowRoot) === null || _t$shadowRoot === void 0 ? void 0 : _t$shadowRoot.querySelector(e.join(","))) || null;
}
function a(t) {
  if (!t) return null;
  var e = ["a[href]", "area[href]", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", "ngc-button", "ngc-icon-button", '[tabindex]:not([tabindex="-1"])'];
  return Array.from(t.querySelectorAll(e.join(",")));
}
export { o as getFirstFocusableElement, a as getFocusableElements };